<template>
  <div class="modify-page">
    <navigation class="header" :theme="{
      background: '#fff',
    }"
    >补充身份信息
    </navigation>
    <div class="form-container">
      <div class="divider"></div>

      <template v-if="showIdCard">
        <div class="add-header ">
          <h3>请拍摄身份证正反面照片</h3>
          <p>仅用于身份审核，请确保身份证边框完整、字迹清晰</p>
        </div>
        <div class="upload-container">
          <div class="item">
            <van-uploader 
              v-model="ID_CARD_FRONT" 
              :max-count="1"
              :max-size="10 * 1024 * 1024" 
              @oversize="onOversize" 
              :after-read="(e)=>afterRead(e,'ID_CARD_FRONT')"
              accept="image/*"
              class="van-uploader-item"
            >
              <img src="./images/img_zheng@2x.png" class="upload-bg">
            </van-uploader>
          </div>
         
          <div class="item">
            <van-uploader 
              v-model="ID_CARD_BACK" 
              :max-count="1"
              :max-size="10 * 1024 * 1024" 
              @oversize="onOversize" 
              :after-read="(e)=>afterRead(e,'ID_CARD_BACK')"
              accept="image/*"
              class="van-uploader-item"
            >
              <img src="./images/img_fan@2x.png" class="upload-bg">
            </van-uploader>
          </div>
        </div>
      </template>
      <template v-if="showHolding">
        <div class="add-header ">
          <h3>请拍摄手持身份证照片</h3>
          <p>请参考示例拍摄本人正面手持身份证照片，须完全露出手肘，确保身份证信息清晰无遮挡</p>
        </div>
        <div class="upload-container">
          <div class="item">
            <img src="./images/img_cankao@2x.png" >
          </div>
          <div class="item">
            <van-uploader 
              v-model="HOLDING_ID_CARD_PHOTO" 
              :max-count="1"
              :max-size="10 * 1024 * 1024" 
              @oversize="onOversize" 
              :after-read="(e)=>afterRead(e,'HOLDING_ID_CARD_PHOTO')"
              accept="image/*"
              class="van-uploader-item"
            >
              <img src="./images/img_shouchi@2x.png" class="upload-bg">
            </van-uploader>
          </div>
        </div>
      </template>
    
    </div>


    <div class="control-box">
      <nd-button class="btn" :disabled="isDisabled" :loading="loading" @click="next">确认提交</nd-button>
    </div>
   
  
  </div>
</template>


<script>
import uploadMixins from '@/assets/uploadMixins'
import { mapActions } from 'vuex'
export default {
  data () {
    return { 
      loading: false,
      ID_CARD_FRONT: [],
      ID_CARD_BACK: [],
      HOLDING_ID_CARD_PHOTO: [],
      needProvide: []
    }
  },
  mixins: [uploadMixins],
  mounted () {
    this.getConfig()
    this.$bus.$emit('ready')
  },

  computed: {
    showIdCard () {
      return ['ID_CARD_FRONT', 'ID_CARD_BACK'].some(item => {
        return this.needProvide.includes(item)
      })
    },
    showHolding () {
      return this.needProvide.includes('HOLDING_ID_CARD_PHOTO')
    },
    isDisabled () {
      return (this.showIdCard && (!this.ID_CARD_FRONT.length || !this.ID_CARD_BACK.length)) || (this.showHolding && !this.HOLDING_ID_CARD_PHOTO.length)
    }
  },
 
  methods: {
    ...mapActions('modify', ['uploadImage', 'getChangeConfig']),
    paramsInit (type) {
      if (!this[type]?.length) return
      return this[type].map(item => {
        return {
          url: item.reqUrl,
          imageType: type
        }
      })
    },
    async getConfig () {
      const { success, data } = await this.getChangeConfig()
      if (success) {
        this.needProvide = data.needProvide || []
      }
    },
    async afterRead (file, type) {
      await this.uploadImg(file, type)
    },
    async next () {
      const images = []
      if (this.showIdCard) {
        images.push(...this.paramsInit('ID_CARD_FRONT'))
        images.push(...this.paramsInit('ID_CARD_BACK'))
      }
      if (this.showHolding) {
        images.push(...this.paramsInit('HOLDING_ID_CARD_PHOTO'))
      }
      this.loading = true
      const { success } = await this.uploadImage({ images })
      this.loading = false
      if (success) {
        this.$message('提交成功', 2000)
        this.$router.go(-1)
      }
    }
     
  }


}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  min-height: 100vh;
  padding-bottom: 20px;
  width: 750px;
  overflow: hidden;
  .divider {
    border-top: 20px solid #f8f8f8;
    height: 0px;
    font-size: 0px;
  }

 
  .btn {
    margin:120px auto 20px;
  }
  .add-header {
    padding: 40px;
    padding-bottom: 0;
    h3{
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    p {
      color: #999;
      font-size: 24px;
    }
  }
  .upload-container{
    margin: 40px;
    position: relative;
    display: flex;
    justify-content: space-between;
    height:212px;
    .item {
        width:322px;
        height:212px;
        position: relative;
        &>img ,.upload-bg{
          width:100%;
          height:100%;
        }
      }
    .van-uploader-item {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
     .upload-bg{
          width:100%;
          height:100%;
        }
      /deep/.van-uploader__wrapper,/deep/.van-uploader__preview,/deep/.van-uploader__preview-image, /deep/.van-uploader__preview-imag img,/deep/.van-uploader__input-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      /deep/.van-uploader__preview-imag img{
        object-fit: cover;
      }
      /deep/.van-uploader__preview-delete {
        width:30px;
        height:30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        top:calc(100% - 20px ) ;
        left:calc(100% - 20px );
        position: absolute;
        
      }
      /deep/.van-uploader__preview-delete-icon {
          font-size: 50px;
          position: initial;
        }
    }
  }

     
}
</style>